export default __webpack_public_path__ + "static/ZRX-78a56509ef2ff44b422f067278860ffd.png";